const DEFAULT_THRESHOLD_STEPS = 10;
const DEFAULT_THRESHOLD = Array.from({
  length: DEFAULT_THRESHOLD_STEPS + 1,
}).map((_, idx) => parseFloat((idx / DEFAULT_THRESHOLD_STEPS).toFixed(2)));

class InviewVideo {
  /**
   * @type {HTMLVideoElement}
   */
  base;

  isPlaying = false;

  debug = false;

  constructor($base) {
    this.base = $base;

    this.init();
  }

  init() {
    this.debug = this.base.dataset.debug === "true";
    this.addIO();
  }

  load() {
    if (this.base.getAttribute("data-lazy") !== "true") {
      if (this.debug) console.log("skipping load");
      return;
    }
    for (let source in this.base.children) {
      let videoSource = this.base.children[source];
      if (
        typeof videoSource.tagName === "string" &&
        videoSource.tagName === "SOURCE"
      ) {
        this.base.src = videoSource.dataset.src;
      }
    }
    this.base.removeAttribute("data-lazy");
    this.base.load();
  }

  play() {
    if (this.debug) console.log("play");
    if (this.isPlaying) {
      return;
    }
    this.isPlaying = true;
    this.playPromise = this.base.play();
    this.playPromise
      .then((_) => {
        this.playPromise = null;
      })
      .catch((e) => console.warn(e));
  }

  pause() {
    if (this.debug) console.log("pause");

    if (this.playPromise) {
      this.playPromise
        .then((_) => {
          this.isPlaying = false;
          this.playPromise = null;
          this.base.pause();
        })
        .catch((e) => console.warn(e));
    } else {
      this.isPlaying = false;
      this.base.pause();
    }
  }

  addIO() {
    this.rootMargin = this.base.dataset.rootmargin;
    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.isPlaying) {
              this.load();
              this.play();
            }
          } else {
            if (this.isPlaying) {
              this.pause();
            }
          }
        });
      },
      {
        rootMargin: this.rootMargin || `100px 0px`,
        root: null,
        threshold: DEFAULT_THRESHOLD,
        delay: 100,
        trackVisibility: true,
      }
    );
    this.io.observe(this.base);
  }
}

export function init() {
  document
    .querySelectorAll("video[data-inview]")
    .forEach((el) => new InviewVideo(el));
}
